import { render, staticRenderFns } from "./FeatureComments.vue?vue&type=template&id=d00a9efa&scoped=true"
import script from "./FeatureComments.vue?vue&type=script&lang=js"
export * from "./FeatureComments.vue?vue&type=script&lang=js"
import style0 from "./FeatureComments.vue?vue&type=style&index=0&id=d00a9efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00a9efa",
  null
  
)

export default component.exports